import type { ChargerRepository } from '@/core/charger'
import type { UseCase } from '@/core/shared'

export const getIsChargerCompatibleWithGunLock:
UseCase<ChargerRepository, 'getIsChargerCompatibleWithGunLock'> = repository => {
  return async (charger) => {
    return await repository.getIsChargerCompatibleWithGunLock(charger)
  }
}
